var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 1C27.3888 1 35 8.61116 35 18C35 27.3888 27.3888 35 18 35C8.61116 35 1 27.3888 1 18C1 8.61116 8.61116 1 18 1Z",
    fill: "#F3F4F6",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 7.25C15.1005 7.25 12.75 9.6005 12.75 12.5C12.75 15.3995 15.1005 17.75 18 17.75C20.8995 17.75 23.25 15.3995 23.25 12.5C23.25 9.6005 20.8995 7.25 18 7.25ZM14.25 12.5C14.25 10.4289 15.9289 8.75 18 8.75C20.0711 8.75 21.75 10.4289 21.75 12.5C21.75 14.5711 20.0711 16.25 18 16.25C15.9289 16.25 14.25 14.5711 14.25 12.5Z",
    fill: "#161616"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2288 21.0792C24.0662 20.9874 23.9226 20.9064 23.8063 20.8372C20.2523 18.7209 15.7481 18.7209 12.194 20.8372C12.0777 20.9064 11.9341 20.9875 11.7714 21.0793C11.0586 21.4814 9.98106 22.0893 9.2429 22.8118C8.78123 23.2637 8.34257 23.8592 8.26283 24.5888C8.17802 25.3646 8.51649 26.0927 9.1955 26.7396C10.367 27.8556 11.7727 28.75 13.591 28.75H22.4093C24.2276 28.75 25.6334 27.8556 26.8048 26.7396C27.4839 26.0927 27.8223 25.3646 27.7375 24.5888C27.6578 23.8592 27.2191 23.2637 26.7575 22.8118C26.0193 22.0893 24.9417 21.4813 24.2288 21.0792ZM12.9615 22.126C16.0426 20.2913 19.9577 20.2913 23.0389 22.126C23.2068 22.226 23.3907 22.3303 23.5834 22.4397C24.296 22.8439 25.1281 23.316 25.7082 23.8838C26.0683 24.2363 26.2218 24.5271 26.2464 24.7517C26.2659 24.9301 26.2208 25.2242 25.7702 25.6535C24.7343 26.6404 23.6818 27.25 22.4093 27.25H13.591C12.3186 27.25 11.266 26.6404 10.2302 25.6535C9.77954 25.2242 9.73445 24.9301 9.75395 24.7517C9.77851 24.5271 9.93202 24.2363 10.2921 23.8838C10.8722 23.316 11.7043 22.844 12.4169 22.4397C12.6095 22.3304 12.7936 22.226 12.9615 22.126Z",
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderUser);
export default __webpack_public_path__ + "static/media/header-user.376f992e407f93775fd3249efaf906cd.svg";
export { ForwardRef as ReactComponent };